import { createRouter, createWebHistory } from 'vue-router';
import { utmTagsLib } from 'freedom-shared';
import type { App } from 'vue';

import { routes } from './routes';
import { handleChunkLoadError } from './handle-chunk-load-error';

export const withRouter = (app: App) => {
  const base = '/avia/'; // Path under which the app is deployed on a server

  const router = createRouter({
    history: createWebHistory(base),
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (to.name === 'OffersResults' && savedPosition) {
        return savedPosition;
      }
      return { top: 0 };
    },
  });

  router.beforeEach((to, from, next) => {
    /**
     * SPA-навигация на MainPage в Freedom Superapp webview не
     * синхронизирует URL хоста с `history.pushState`/`replaceState`
     * — пользователь видит белый экран после router.push/replace
     * на главную с Favorites/Booking/Payment/любой другой страницы.
     * `ResultsPage.backToMainPage` обходит это через
     * `window.location.replace(href)` (SEARCH-1062); делаем это
     * централизованно для всех source-страниц.
     */
    if (to.name === 'MainPage' && from.name && from.name !== 'MainPage') {
      const { href } = router.resolve(to);
      window.location.replace(href);
      next(false);
      return;
    }

    const locationWithUtmTags = utmTagsLib.getLocationWithUtmTags(to, from);

    if (locationWithUtmTags) {
      next(locationWithUtmTags);
    } else {
      next();
    }
  });

  handleChunkLoadError(router);

  app.use(router);

  return router;
};
